import { SideListOptionType } from '../types/side-list-option-type';
import { IItemsListDataFetchParams, IItemsListParameterBase } from '../fi-items-list/fi-items-list';
import { FiAppSettings } from '../fi-app-settings';
import { IItemsListFilterSettings } from '../fi-items-list/fi-items-list-filter/fi-items-list-filter/fi-items-list-filter';

export class FiLocalSearchParameterModel implements IItemsListParameterBase {
    Names: string[] = [];
    Descriptions: string[] = [];
    ContentSearchTexts: string[] = [];
    KeywordsSearchTexts: string[] = [];
    TagIds: number[] = [];
    CreatedByUserNames: string[] = [];
    BusinessAreaIds: number[] = [];
    Offset = 0;
    NumberOfRecordsToTake = FiAppSettings.NumberOfRecordsPerPage;
    FilterType = SideListOptionType.SharedWithMe;
    SelectedSort = {};
    FetchParams?: IItemsListDataFetchParams;
    FilterSettings: IItemsListFilterSettings;
    IsSuperAdminAccess: boolean;
}
